const BILLING_SYSTEMS = {
    INTERNAL: 'INTERNAL',
    TWO_CHECKOUT: 'TWO_CHECKOUT',
    APPSUMO: 'APPSUMO',
    STRIPE: 'STRIPE',
}

export default BILLING_SYSTEMS
